import * as Sentry from '@sentry/browser';
import { notifyError } from '@rsos/utils/toastUtils';
import {
  AIR_AMBULANCE_CANCEL_ERROR_NOTIFICATION,
  AIR_AMBULANCE_CANCEL_FAILED_LOG,
} from './constants';

/**
 * handleCancelFailed notifies the user and logs the error when an air ambulance
 * cancellation attempt fails.
 * @param logReason - Brief reason for the cancellation failure.
 * @param logData - Data to be logged.
 */
export const handleCancelFailed = (
  logReason: string,
  logData: Record<string, unknown>,
): void => {
  // Use type assertion to allow custom context structure
  // The test mocks Sentry so the structure is intentional
  Sentry.captureException(new Error(AIR_AMBULANCE_CANCEL_FAILED_LOG), {
    reason: logReason,
    ...logData,
  } as Parameters<typeof Sentry.captureException>[1]);

  notifyError(AIR_AMBULANCE_CANCEL_ERROR_NOTIFICATION);
};
